<template>
	<div class="container-fluid pb-3" style="padding-top: 80px; min-height: 100vh">
		<!-- eslint-disable-next-line vue/no-v-html -->
		<dynamic-page />
	</div>
</template>

<script>
	import DynamicPage from '~/components/dynamic-page'

	export default {
		components: {
			DynamicPage
		}
	}
</script>

<style lang="css" scoped>
</style>
